<template>
  <div class="uMonitoringData" ref="meRunningTime">
    <div class="umdBox">
      <div class="boxLeft">
        <div class="leftTitle">
          <div
            class="titleItem"
            :style="{ width: leftItemWidth[i] + 'px' }"
            v-for="(item, i) in leftTitleList"
            :key="i"
          >
            {{ item }}
          </div>
        </div>
        <div class="leftList">
          <div class="listItem" v-for="(item, i) in computeLeftList" :key="i">
            <div :style="{ width: leftItemWidth[0] + 'px' }">{{ item[0] }}</div>
            <div class="allOnline" :style="{ width: leftItemWidth[1] + 'px' }">
              <count-too class="number" :value="item[1]"></count-too>
              <count-too class="number" :value="item[2]"></count-too>
            </div>
          </div>
        </div>
      </div>
      <div class="boxLeft boxRight">
        <div class="leftTitle">
          <div
            class="titleItem"
            :style="{ width: rightItemWidth[i] }"
            v-for="(item, i) in rightTitleList"
            :key="i"
          >
            {{ item }}
          </div>
        </div>
        <div class="leftList">
          <div class="listItem" v-for="(item, i) in rightList" :key="i">
            <div :style="{ width: rightItemWidth[0] }">{{ item.metric }}</div>
            <div :style="{ width: rightItemWidth[1] }">{{ item.unit }}</div>
            <count-too
              class="number color3"
              :style="{ width: rightItemWidth[2] }"
              :value="item.avgValue"
              :decimals="2"
            ></count-too>
            <count-too
              v-if="customerId != 89"
              class="number color4"
              :style="{ width: rightItemWidth[3] }"
              :value="item.maxValue"
              :decimals="2"
            ></count-too>
            <count-too
              v-if="customerId != 89"
              class="number color5"
              :style="{ width: rightItemWidth[4] }"
              :value="item.minValue"
              :decimals="2"
            ></count-too>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countToo from "@/components/vueCountTo";
export default {
  components: { countToo },
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: "U_monitoringData.vue",
      computedName: "无组织监控数据组件",
      customerId: this.$store.state.customerId,
      leftTitleList: ["设备类型", "在线/总数"],
      leftList: [
        { type: "空间质量微站", online: 64, total: 67 },
        { type: "TSP检测仪", online: 58, total: 65 },
        { type: "VDM检测仪", online: 34, total: 44 },
        { type: "含水率检测仪", online: 2, total: 3 },
      ],
      leftItemWidth: ["102", "76"],
      rightTitleList: ["监测指标", "单位", "平均值", "最大值", "最小值"],
      rightList: [
        { type: "PM10", unit: "ug/m³", avg: 55.63, max: 1999.9, min: 34 },
        { type: "TSP", unit: "mg/m³", avg: 4.29, max: 7.77, min: 2.78 },
        { type: "含水率", unit: "%", avg: 6.4, max: 8.9, min: 3.8 },
      ],
      rightItemWidth: ["19.5%", "19.5%", "19.5%", "19.5%", "19.5%"],
    };
  },
  computed: {
    // 数据异常则显示0
    countNum() {
      return (num) => (!isNaN(num) ? num : 0);
    },
    computeLeftList() {
      // const arr = this.leftList.filter(l => l[1] !== 0);
      const arr = this.leftList.filter((l) => l[2] !== 0);
      return arr;
    },
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.meRunningTime).outerWidth();
    let h = $(that.$refs.meRunningTime).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    // this.test();
    this.getListData();
    if (window.bmeConfig.customerSign == 89) {
      this.rightTitleList = ["监测指标", "单位", "平均值"];
      this.rightItemWidth = ["33.3%", "33.3%", "33.3%"];
    } else {
      this.rightTitleList = ["监测指标", "单位", "平均值", "最大值", "最小值"];
      this.rightItemWidth = ["19.5%", "19.5%", "19.5%", "19.5%", "19.5%"];
    }
    if (window.bmeConfig.customerSign == 15) {
      this.leftList = [
        { type: "空间质量微站", online: 64, total: 67 },
        { type: "TSP检测仪", online: 58, total: 65 },
        { type: "含水率检测仪", online: 2, total: 3 },
      ];
    }
  },
  unmounted() {},
  methods: {
    // 每小时获取列表
    async getListData() {
      this.clearTimer(this.getlistTimer);
      let getUmonitoringData =
        CONFIG.requestName + this.$apiOpt.getUmonitoringData;
      let res = await this.$apiUtils.get(getUmonitoringData, {
        customerId: this.customerId,
      });
      // let res = {
      //   tspTypeName: "TSP监测仪",
      //   tspTotal: 187,
      //   tspOnLineTotal: 187,
      //   vdmTypeName: null,
      //   vdmTotal: null,
      //   vmdOnLineTotal: null,
      //   airTypeName: "空气质量微站",
      //   airTotal: 52,
      //   airOnLineTotal: 52,
      //   waterTypeName: "含水率监测仪",
      //   waterTotal: 9,
      //   waterOnLineTotal: 9,
      //   list: [
      //     {
      //       metric: "PM10",
      //       unit: "ug/m3",
      //       avgValue: "23.32",
      //       maxValue: "129.30",
      //       minValue: "0.00",
      //     },
      //     {
      //       metric: "TSP",
      //       unit: "mg/m3",
      //       avgValue: "0.46",
      //       maxValue: "30.04",
      //       minValue: "0.01",
      //     },
      //     {
      //       metric: "含水率",
      //       unit: "%",
      //       avgValue: "2.71",
      //       maxValue: "11.85",
      //       minValue: "0.00",
      //     },
      //   ],
      // };
      if (res) {
        console.log("res1235", res);
        let data = JSON.parse(JSON.stringify(res));
        if (this.customerId == 15) {
          this.leftList = [
            [data.airTypeName, data.airOnLineTotal, data.airTotal],
            [data.tspTypeName, data.tspOnLineTotal, data.tspTotal],
            [data.waterTypeName, data.waterOnLineTotal, data.waterTotal],
          ];
        } else if (this.customerId == 110) {
          this.leftList = [
            [data.airTypeName, data.airOnLineTotal, data.airTotal],
            [data.tspTypeName, data.tspOnLineTotal, data.tspTotal],
          ];
        } else {
          this.leftList = [
            [data.airTypeName, data.airOnLineTotal, data.airTotal],
            [data.tspTypeName, data.tspOnLineTotal, data.tspTotal],
            [data.vdmTypeName, data.vmdOnLineTotal, data.vdmTotal],
            [data.waterTypeName, data.waterOnLineTotal, data.waterTotal],
          ];
        }

        this.rightList = data.list;
        if (this.customerId === 66) {
          this.leftList.pop();
          this.rightList.pop();
        }
        if (this.customerId === 110) {
          this.rightList.pop();
        }
      }
      this.getlistTimer = setTimeout(() => {
        this.getListData();
      }, 60 * 1000);
    },
    test() {
      this.clearTimer(this.testTimer);
      this.leftList.forEach((i) => {
        i.online += 1;
        i.total += 1;
      });
      this.rightList.forEach((i) => {
        i.avg += 2;
        i.max += 3;
        i.min += 1;
      });
      // this.rightList = JSON.parse(JSON.stringify(this.rightList));
      console.log(this.rightList);
      this.testTimer = setTimeout(() => {
        this.test();
      }, 2 * 1000);
    },
    // 清除定时器
    clearTimer(timer) {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped="scoped">
.uMonitoringData {
  height: 250px;
  width: 600px;
  .umdBox {
    margin-top: 35px;
    display: flex;
    justify-content: space-between;
    //background: url('./img/back.png') no-repeat 100%;
    .boxLeft {
      width: 178px;
      text-align: center;
      font-size: 14px;
      .leftTitle {
        display: flex;
        height: 32px;
        line-height: 32px;
      }
      .leftList {
        .listItem {
          height: 38px;
          line-height: 38px;
          display: flex;
          text-indent: 4px;
          > .allOnline {
            display: flex;
            justify-content: space-between;
            padding: 0 10px 0 8px;
            > span:nth-child(1) {
              color: rgba(71, 255, 221, 1);
            }
            > span:nth-child(2) {
              color: rgba(244, 196, 143, 1);
            }
          }
        }
      }
    }
    .boxRight {
      width: 362px;
      height: 180px;
      .leftTitle {
        /* height: 44px;
        line-height: 44px;*/
      }
      .leftList {
        .listItem {
          /*  height: 42px;
          line-height: 42px;*/
          padding: 0;
        }
      }
      .color3 {
        color: rgba(145, 209, 249, 1);
      }
      .color4 {
        color: rgba(81, 238, 255, 1);
      }
      .color5 {
        color: rgba(174, 255, 177, 1);
      }
    }
  }
}
</style>
